import React, { Component } from 'react'
const EventPaths = {
	"marche": "regionali-2025-09",
	"valle-d-aosta": "regionali-2025-09",
	"calabria": "regionali-2025-10",
	"toscana": "regionali-2025-10"
}

class EWH extends Component {
    componentDidMount() {
        if (!this._Mounted) {
        this._Mounted = true;
        const script = document.createElement('script')
        script.src = '/elezioni/withub/regionali-2024-10/js/main-load.js'
        script.dataset.repo = this.props.repo
		script.dataset.title = this.props.title	? this.props.title : ""
        script.dataset.id = this.props.id
		script.setAttribute('data-url', this.props.url)
        script.crossorigin = 'anonymous'
        script.async = true
        this.div.appendChild(script)
        }
    }
    getPath(entity) {
	    return EventPaths[entity];
    }
    render() {
        return <div ref={(el) => (this.div = el)}></div>
    }
}

export default EWH
